import { InteractiveMapData, InteractiveMapPOIData } from '../../../Content';

import ContentPopup from '../content_popup/ContentPopup';
import { InteractiveMap } from '../InteractiveMap';
import { InteractiveMapPOI } from '../InteractiveMapPOI';
import { useScene } from '../../../contexts/SceneContext';
import { useState } from 'react';

interface Props {
  content: InteractiveMapData;
}

export const InteractiveMapContent: React.FC<Props> = ({
  content: { aspect = 1, ...content },
}) => {
  const { parseContentPath } = useScene();

  const [activePOI, setActivePOI] =
    useState<InteractiveMapPOIData | null>(null);

  return (
    <>
      <InteractiveMap aspect={aspect} imageSrc={parseContentPath(content.src)}>
        {content.points.map((poi) => (
          <InteractiveMapPOI
            key={poi.tooltip}
            position={poi.position}
            tooltip={poi.tooltip}
            onClick={() => setActivePOI(poi)}
          />
        ))}
      </InteractiveMap>
      {activePOI && (
        <ContentPopup
          content={activePOI.content}
          closeBtnText="Back"
          onCloseRequested={() => setActivePOI(null)}
        />
      )}
    </>
  );
};
